import type { AxiosResponse } from 'axios'
import type {
  QueryTransactionHistoryListModel,
  QueryTransactionHistoryListParameters,
} from './model/transactionHistory'

import { handleAPIException } from '@/utils/exception'
import { bffHTTP } from '@/utils/http/axios'

export async function queryTransactionHistory(
  parameters: QueryTransactionHistoryListParameters
): Promise<QueryTransactionHistoryListModel> {
  try {
    const response: AxiosResponse<QueryTransactionHistoryListModel, any> = await bffHTTP({
      url: '/transactions',
      method: 'GET',
      params: parameters,
    })

    handleAPIException(response)
    return response.data
  } catch (error) {
    console.warn('queryTransactionHistory', error)
    return {} as QueryTransactionHistoryListModel
  }
}
